// import { Component, Input, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-customer-profile',
  templateUrl: './customer-profile.component.html',
  styleUrls: ['./customer-profile.component.css']
})
export class CustomerProfileComponent implements OnInit {

  @Input() public custProfile;

  // constructor(private NgbModal: NgbModal) { }
  constructor(public activeModal : NgbActiveModal) { }

  ngOnInit(): void {
   

  }
  
  
 
onClose(){
  this.activeModal.close();
}

}